module.exports = __webpack_public_path__ + "img/handyman.d053ece0.jpeg";